<template>
  <ul v-if="pager.pages && pager.pages.length" class="pagination flex items-center gap-[28px] mt-[45px] w-[335px]" :style="ulStyles">
    <li class="page-item first" :class="{'disabled': pager.currentPage === 1}" :style="liStyles">
      <LeftDblArrowIcon @click="setPage(1)" :isDisabled="pager.currentPage === 1" class="cursor-pointer" />
    </li>
    <li class="page-item previous" :class="{'disabled': pager.currentPage === 1}" :style="liStyles">
      <LeftArrowIcon @click="setPage(pager.currentPage - 1)" :isDisabled="pager.currentPage === 1" class="cursor-pointer" />
    </li>

    <li class="w-[167px] text-[#2A4067] text-[25px] text-center leading-[30px] font-inter-regular">Page {{ pager.currentPage }} of {{ pager.totalPages }}</li>

    <li class="page-item next" :class="{'disabled': pager.currentPage === pager.totalPages}" :style="liStyles">
      <RightArrowIcon @click="setPage(pager.currentPage + 1)" :isDisabled="pager.currentPage === pager.totalPages" class="cursor-pointer" />
    </li>
    <li class="page-item last" :class="{'disabled': pager.currentPage === pager.totalPages}" :style="liStyles">
      <RightDblArrowIcon @click="setPage(pager.totalPages)" :isDisabled="pager.currentPage === pager.totalPages" class="cursor-pointer" />
    </li>
  </ul>
</template>

<script>
import paginate from 'jw-paginate';
import { mapGetters } from 'vuex';
import { maxTableRows } from '@/utils/pagination';
import LeftDblArrowIcon from '@/components/svg/LeftDblArrow';
import RightDblArrowIcon from '@/components/svg/RightDblArrow';
import LeftArrowIcon from '@/components/svg/LeftArrow';
import RightArrowIcon from '@/components/svg/RightArrow';

const defaultLabels = {
  first: 'First',
  last: 'Last',
  previous: 'Previous',
  next: 'Next'
};

const defaultStyles = {
  li: {
    listStyle: 'none',
    display: 'inline',
    textAlign: 'center'
  },
  a: {
    cursor: 'pointer',
    padding: '6px 12px',
    display: 'block',
    float: 'left'
  }
};

export default {
  name: "PaginationComponent",
  components: {
    LeftDblArrowIcon,
    RightDblArrowIcon,
    LeftArrowIcon,
    RightArrowIcon
  },
  props: {
    items: {
      type: [Number, String],
      required: true
    },
    initialPage: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: maxTableRows
    },
    maxPages: {
      type: Number,
      default: maxTableRows
    },
    labels: {
      type: Object,
      default: () => defaultLabels
    },
    styles: {
      type: Object
    },
    disableDefaultStyles: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      pager: {},
      ulStyles: {},
      liStyles: {},
      aStyles: {},
    }
  },
  watch: {
    items() {
      const { items, pageSize, maxPages } = this;
      const currentPage = this.pager.currentPage || this.initialPage;
      const nextPager = paginate(items, currentPage, pageSize, maxPages);
      this.pager = nextPager;
    }
  },
  created () {
    // set default styles unless disabled
    if (!this.disableDefaultStyles) {
      this.ulStyles = defaultStyles.ul;
      this.liStyles = defaultStyles.li;
      this.aStyles = defaultStyles.a;
    }

    // merge custom styles with default styles
    if (this.styles) {
      this.ulStyles = { ...this.ulStyles, ...this.styles.ul };
      this.liStyles = { ...this.liStyles, ...this.styles.li };
      this.aStyles = { ...this.aStyles, ...this.styles.a };
    }

    const { items, pageSize, maxPages } = this;
    this.pager = paginate(items, this.initialPage, pageSize, maxPages);
  },
  methods: {
    setPage(page) {
      const { items, pageSize, maxPages } = this;
      if (page === this.pager.currentPage) return;
      const pager = paginate(items, page, pageSize, maxPages);
      // get new pager object for specified page

      // update pager
      this.pager = pager;

      // emit current page number; parent computes skip from it.
      this.$emit('changePage', { page: this.pager.currentPage });
    }
  }
}
</script>
